import React from 'react'
import { connect } from 'react-redux'
import classnames from 'classnames'
import RMB from '@/assets/images/icons/bottom_icon_China.png'
import HKD from '@/assets/images/icons/bottom_icon_hk.png'
import { utilsFunction } from '@/helpers/functions'
import { getSafe } from '@/helpers/global';
import { getAccountBalanceAction } from '@/actions/trading'
import { PARAMS as requestParams } from '@/constants/params';

class CurrencyBalance extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      detailsList: [{
        buyingPower: "100.0",
        currencyID: "HKD",
        dueBalance: "0",
        ledgerBalance: "0",
        settledBalance: "0",
        todayBuy: "0",
        todayConfirmBuy: "0",
        todayConfirmSell: "0",
        todaySell: "0",
        todaySettlement: "0",
        withdrawableBalance: "0",
      },
      {
        buyingPower: "0.0",
        currencyID: "RMB",
        dueBalance: "0",
        ledgerBalance: "0",
        settledBalance: "0",
        todayBuy: "0",
        todayConfirmBuy: "0",
        todayConfirmSell: "0",
        todaySell: "0",
        todaySettlement: "0",
        withdrawableBalance: "0",
      },
      ]
    }
  }

  flag = (value) => {
    switch (value) {
      case 'HKD': {
        return HKD;
      }
      case 'RMB': {
        return RMB;
      }
    }
  }

  render() {
    let { language } = this.props
    const { detailsList } = this.state
    return (
      <div className={classnames("section", 'currency-balance', "overflow")}>
        <div className="section-title">
          {getSafe(() => language.cash_title)}
        </div>
        <div className="section-content currency-balance-box">
          {
            detailsList ? detailsList.map(value =>
              <div className={classnames("currency-balance-item")} key={value.currencyID}>
                <div className={classnames("currency-balance-title")}>
                  <div className="currency-ccy-iocn">
                    <img className="auto-img" src={this.flag(value.currencyID)} alt="ccy-China" />
                  </div>
                  {value.currencyID}
                </div>

                <div className={classnames("currency-balance-content-top")}>
                  {getSafe(() => language.cash_total_availabel_funds)}
                </div>
                <div className={classnames("currency-balance-content-bottom")}>
                  {utilsFunction.currencyFormatter(value.ledgerBalance)}
                </div>

                <div className={classnames("currency-balance-content-top")}>
                  {getSafe(() => language.cash_current_balance)}
                </div>
                <div className={classnames("currency-balance-content-bottom")}>
                  {utilsFunction.currencyFormatter(value.withdrawableBalance)}
                </div>
              </div>
            ) : ''
          }
        </div>
      </div>
    )
  }

  getAccountBalance() {
    const { user, tradingAccount, language } = this.props
    const { clientID, tradingAccSeq } = tradingAccount
    const params = {
      [requestParams.CLIENT_ID]: clientID,
      [requestParams.TRADING_ACCOUNT_ID]: clientID,
      [requestParams.LANGUAGE]: language.lang,
      [requestParams.SHOW_DETAILS]: 'Y'
      // [requestParams.TRADING_ACC_SEQ]: tradingAccSeq,
      // [requestParams.MARKET_ID]: ,
      // [requestParams.CURRENCY_ID]: ,
    }
    this.props.getAccountBalance(params, res => {
      let newDatails = Object.assign([], this.state.detailsList, res.result.detailsList)
      this.setState({
        detailsList: newDatails
      })
    })
  }

  componentDidMount() {
    this.getAccountBalance()
  }

  componentDidUpdate(preProps) {
    const { user } = this.props

    if (preProps.user !== user) {
      this.getAccountBalance()
    }
  }

  componentWillUnmount() {
    this.setState = () => {
      return
    }
  }
}

export default connect(
  state => ({
    language: state.app.language,
    user: state.auth.user,
    tradingAccount: state.auth.tradingAccount
  }),
  dispatch => ({
    getAccountBalance: (p, c) => dispatch(getAccountBalanceAction(p, c))
  })
)(CurrencyBalance)